import { render, staticRenderFns } from "./SuperPDPCallback.vue?vue&type=template&id=986e6bc2&"
import script from "./SuperPDPCallback.vue?vue&type=script&lang=js&"
export * from "./SuperPDPCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports